import { MariageContractType } from "../../types/commonTypes/mariageContractType";

export const mariageContractInitialState: MariageContractType = {
    editor: "",
    editPlace: "",
    editDate: ""
}